import React, { useEffect, useState } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { connect, Provider } from 'react-redux';
import { ChakraProvider } from '@chakra-ui/react';
import theme from '../../theme';
// cmx
import CMx from '../cmx/cmx-component';
import Login from '../login/login-component';
import AmplifyDeprecated from '../../views/amplify-deprecated/amplify-deprecated';
import store, { history } from '../../store/store';
import '../../core/session-management';
import '../../core/register-case-accelerator-worker';

import { isNewDesign } from '../../core/middleware/new-design-middleware';
// assets (shared styles loaded via ../../styles in entry)
import '@fontsource/roboto';

import { getConfig } from '../../actions/login.action';

function Template() {
  const [isNewDesign2, setIsNewDesign2] = useState(false);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const { newDesign } = await getConfig();
        setIsNewDesign2(newDesign?.enabled);
      } catch (err) {
        console.error('[Main] Failed to load global config; new-design flag defaults to false.', err);
      }
    };
    fetchConfig();
  }, [isNewDesign2]);

  const routableApp = (
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          <Route path={['/accelerate', '/accelerate/']} component={AmplifyDeprecated} />
          <Route path="/cmx" component={CMx} />
          <Route
            exact
            path={[
              '/',
              '/choose/context/',
              '/update-password/',
              '/forgot-password/',
              '/forgot-password/reset/',
              '/eula/',
              '/choose/service-line/',
              '/sso/:orgCode?'
            ]}
            component={Login}
          />
        </Switch>
      </Router>
    </Provider>
  );

  if (isNewDesign || isNewDesign2) {
    return <ChakraProvider theme={theme}>{routableApp}</ChakraProvider>;
  }
  return routableApp;
}

export default Template;
